import React, { Component } from 'react';

import { connect }          from 'react-redux';

import { withRouter }       from 'react-router-dom';

import { getBranche }       from '../../../redux/branches/details/actions';
import { 
    addRoute,
    updateRoute,
    getRoutes
}                           from '../../../redux/routes/list/actions';
import { getRoutesForBranche } from '../../../redux/routes/list/selectors';

import { getUnplannedRoutes } from '../../../redux/unplanned-routes/actions';
import { getUnplannedRoutesForBranche } from '../../../redux/unplanned-routes/selectors';

import { getVehiclesWithNoRoute } from '../../../redux/vehicles/selectors';

import Page                 from '../../../components/page/Page';
import Map                  from '../../../components/maps/Map';
import Marker               from '../../../components/maps/Marker';
import RouteLayer           from '../../../components/maps/layers/RouteLayer';
import ErrorState           from '../../../components/state/ErrorState';
import LoadingState         from '../../../components/state/LoadingState';
import Truck from '../../../components/maps/markers/Truck';

import Dashboard            from '../../../lib/api/Dashboard';

import RouteInfo            from './info/RouteInfo';

import Stops from './stops/Stops';


const INTERNAL_BRANCH_NUMBER = '9000';

class Details extends Component {
    
    componentDidMount() {
        
        const { dispatch, match: { params } } = this.props;

        if (params.branche_id) {
            dispatch(getBranche(params.branche_id)).then((action) => {
            
                const { error } = action;
                const { data={} } = action.data || {};

                if (data) {

                    const now = new Date();
                    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

                    dispatch(getRoutes({
                        branch_nummer: [data.number, INTERNAL_BRANCH_NUMBER],
                        createdAt: { $gte: today.getTime() }
                    }));

                    dispatch(getUnplannedRoutes({
                        branch_nummer: data.number,
                        createdAt: { $gte: today.getTime() }
                    }));

                    const id = data.id;

                    this.dashboard_route_created = Dashboard.subscribe('/route/created', { branche: { id:data.id} }, (data) => {
                        dispatch(addRoute(data));
                    });

                    this.dashboard_route_updated = Dashboard.subscribe('/route/updated', {branche: { id:data.id }}, (data) => {
                        dispatch(updateRoute(data));
                    });

                    // TODO: 
                    // Subscribe for addUnplannedRoute + updateUnplannedRoute 
                }
            });
        }
    }

    componentWillUnmount() {

        if (this.dashboard_route_created) {
            this.dashboard_route_created.remove();
        }

        if (this.dashboard_route_updated) {
            this.dashboard_route_updated.remove();
        }
    }

    renderRouteLayers() {
        const { data, route_list, match: { params }  } = this.props;

        if (!route_list.length) { return null; }

        const route_layers = route_list.map((route_id) => {
            return (
                <RouteLayer
                    key={route_id}
                    branche_id={params?.branche_id}
                    route_id={route_id}
                    stops={false}
                    onClick={() => {
                        this.props.history.push('/groothandels/' + data.documentId + '/routes/' + route_id);
                    }}
                />
            );
        });

        return route_layers;
    }

    renderInternalRouteLayers() {
        const { data, internal_route_list, match: { params }  } = this.props;

        if (!internal_route_list.length) { return null; }

        const route_layers = internal_route_list.map((route_id) => {
            return (
                <RouteLayer
                    key={route_id}
                    branche_id={params?.branche_id}
                    route_id={route_id}
                    stops={false}
                    onClick={() => {
                        this.props.history.push('/groothandels/' + data.documentId + '/routes/' + route_id);
                    }}
                />
            );
        });

        return route_layers;
    }


    renderVehiclesWithNoRoute() {
        const { vehicles_no_route } = this.props;

        if (!vehicles_no_route.length) { return null; }

        const vehicles = vehicles_no_route.map((vehicle) => {
  
            const { latitude, longitude, rotation, licenseplate, extraData, positionUpdated } = vehicle;

            return (
                <Truck
                    position={{
                        latitude: latitude,
                        longitude: longitude
                    }}
                    rotation={rotation}
                    color={'#cda3c9'}
                    infoWindowContent={
                        <div className='infowindow'>
                            {
                                (extraData?.driverId && extraData?.driverId !== '')
                                ?
                                <div className='name'>Chauffeur id: { extraData.driverId }</div>
                                :
                                <div className='name'>Chauffeur onbekend</div>
                            }
                            
                            { licenseplate !== null ? <div className='name'>{ licenseplate }</div> : null }
                            { positionUpdated ? <><br /><div className='name'>Positie bijgewerkt: </div>{ new Date(positionUpdated).toLocaleString('nl-NL') }</> : null }
                        </div>
                    }
                    type={'normal'}
                />
            );
        });

        return vehicles;
    }

    onBack = () => {

        const { history } = this.props;
        history.push('/groothandels');
    }

    render() {
        const { data, route_list, internal_route_list, unplanned_route_list, error, loading,  match: { params } } = this.props;
        const { latitude, longitude, color } = data;

        if (loading) { return <LoadingState label="Bezig met laden..." />; }
        if (error) { return <ErrorState label="Er is een fout opgetreden" message={error.message} />; }

        if (!Object.keys(data).length) { return null; }

        return (
            <Page onBack={this.onBack}>

                <div style={ {position: 'relative', height:'100%'} }>

                    <div className="sidebar">
                        
                        <div className="card">
                            <h2 style={ {margin:0, padding:20} }>{data.name}</h2>
                        </div>
            
                        <RouteInfo
                            branche_id={data.documentId}
                            route_list={route_list}
                            internal_route_list={internal_route_list}
                            unplanned_route_list={unplanned_route_list}
                        />

                    </div>

                        <Map
                            zoom={10}
                            panX={-200}
                            center={{
                                latitude: latitude,
                                longitude: longitude
                            }}
                            streetViewControl={true}
                        >
                            <Marker
                                position={{
                                    latitude: latitude,
                                    longitude: longitude
                                }}
                                icon={{
                                    path: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z',
                                    fillColor: color,
                                }}
                            />

                            <Stops branche_id={params.branche_id} />
                
                            { this.renderVehiclesWithNoRoute() }
                            
                            { this.renderRouteLayers() }

                            { this.renderInternalRouteLayers() }
                      
                        </Map>
 
                </div>

            </Page>
        );
    }
}

function mapStateToProps(state, props) {

    const { data, error, loading } = state.branches.current;

    const routes = getRoutesForBranche(state, data.number);
    const routeIds = routes.map(route => route.documentId);

    const unplannedRoutes = getUnplannedRoutesForBranche(state, data.number);
    const unplannedRouteIds = unplannedRoutes.map(route => route.documentId);

    const internalRoutes = getRoutesForBranche(state, INTERNAL_BRANCH_NUMBER);

    const customerNumbers = (typeof data.customer_numbers === 'string' ? data.customer_numbers : '')
    .split(',')
    .map((number) => number.trim())
    .filter((number) => number.length > 0);

    const internalRoutesForBranch = [];
    internalRoutes.forEach((route) => {
        const { activities = [] } = route; 
        activities.forEach(({ customer_number }) => { 
            if (customer_number === data.number || customerNumbers.includes(customer_number)) {
                internalRoutesForBranch.push(route);
            }
        });
    });

    const internalRouteIds = internalRoutesForBranch.map(route => route.documentId);

	return {
        data: data,
        error: error,
        loading: loading,
        route_list: routeIds,
        internal_route_list: internalRouteIds,
        unplanned_route_list: unplannedRouteIds,
        vehicles_no_route: getVehiclesWithNoRoute(state, state.routes.all.data, data.number)
	};
}

export default connect(mapStateToProps)(withRouter(Details));
